<template>
  <div class="filterBar">
    <div class="item" v-for="(item, index) in options.filterData" :key="index">
      <div class="label">
        {{ item.name }}
      </div>
      <div class="info">
        <span v-for="(subItem, subIndex) in item.dictData" :class="{ checked: subItem.checked }" :key="subIndex"
          @click="checkItem(item, subItem, subIndex)">
          {{ subItem.dictName }}
        </span>
        <!-- 区间组件 -->
        <div class="numberRange" v-if="item.type === 'asset_price'">
          <div class="box">
            <div class="input-box">
              <div class="input">
                <el-input-number style="width: 80px; margin: 0 0px; height: 32px" :controls="false"
                  v-model="options.min" />
              </div>
              <div class="symbol">-</div>
              <div class="input" style="margin-right: 15px">
                <el-input-number style="width: 80px; margin: 0 0px; height: 32px" :controls="false"
                  v-model="options.max" />
              </div>
            </div>
            <div class="button-box">
              <span @click="empty(index, 'asset_price')" class="clear">清空</span>
              <el-button type="primary" @click="subPrice(index)">确认</el-button>
            </div>
          </div>
        </div>
        <div class="numberRange" v-if="item.type === 'asset_quantity'">
          <div class="box quantity">
            <div class="input-box">
              <div class="input">
                <el-input-number style="width: 80px; margin: 0 0px; height: 32px" :controls="false"
                  v-model="options.quantityStart" />
              </div>
              <div class="symbol">-</div>
              <div class="input" style="margin-right: 15px">
                <el-input-number style="width: 80px; margin: 0 0px; height: 32px" :controls="false"
                  v-model="options.quantityEnd" />
              </div>
            </div>
            <div class="button-box">
              <span @click="empty(index, 'asset_quantity')" class="clear">清空</span>
              <el-button type="primary" @click="subPrice(index)">确认</el-button>
            </div>
          </div>
        </div>
        <!-- 时间组件 -->
        <div class="dateRange" v-if="item.type === 'asset_publish'">
          <!-- <el-date-picker format="YYYY-MM-DD" v-model="options.date" style="margin-right: 15px" type="datetimerange"
            range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间" @focus="subDate(item, index)"
            @change="subDate(item, index)" /> -->
          <el-date-picker v-model="options.date" style="margin-right: 15px" type="daterange" range-separator="-"
            start-placeholder="开始时间" end-placeholder="结束时间" @focus="subDate(item, index)"
            @change="subDate(item, index)" />
          <!-- <el-button type="primary" @click="subDate(item, index)">确认</el-button> -->
        </div>
      </div>
    </div>
    <div class="item" v-for="(item, index) in options.filterData" :key="index" v-show="item.type === 'asset_price'">
      <div class="label">资产搜索</div>
      <div class="info">
        <div class="input" style="margin-right: 15px">
          <el-input style="width: 200px; margin: 0 0 0 10px; height: 32px" :controls="false" v-model="options.text"
            placeholder="资产名称/编号" clearable />
        </div>
        <el-button type="primary" @click="quantext(index)">确认</el-button>
      </div>
    </div>
    <div class="item">
      <div class="label">已选条件</div>
      <div class="info">
        <el-tag v-for="(item, index) in checkList" :key="index" class="mx-1" closable :disable-transitions="false"
          @close="handleClose(item)">
          {{ item.dictName }}
        </el-tag>
        <el-button v-if="checkList.length" type="primary" @click="clear()">一键清空</el-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { reactive, watch, computed, onMounted } from "vue";
import { getSubordinateAreaById } from "@/api/myhire";
import { getDistTypesData, getAreaByType } from "@/api/tool";
import _ from 'lodash'
const emit = defineEmits(["change", "clearAll"]);
const enumList = [
  {
    name: '资产类型',
    type: 'flow_assets_assets_type',
    query: 'assetType',
    dictData: []
  },
  {
    name: '资产地市',
    type: 'city',
    query: 'city',
    dictData: []
  },
  {
    name: '资产区域',
    type: 'region',
    query: 'region',
    dictData: [
      {
        dictValue: -1,
        dictName: '全部',
        checked: true
      }
    ]
  },
  {
    name: '价格范围',
    type: 'asset_price',
    query: 'priceQuery',
    dictData: []
  }, {
    name: '计租数量',
    type: 'asset_quantity',
    query: 'quantityQuery',
    dictData: []
  }, {
    name: '发布日期',
    type: 'asset_publish',
    query: 'publishTimeQuery',
    dictData: []
  }, {
    name: '资产分类',
    type: 'flow_assets_category',
    query: 'assetClassify',
    dictData: []
  },
]
const options: any = reactive({
  min: null,
  max: null,
  quantityStart: null,
  quantityEnd: null,
  date: [],
  filterData: [],
  queryParams: {},
});
const checkList = computed(() => {
  let aList: any = [];
  options.filterData.forEach((e: any, i: any) => {
    if (e.dictData.length) {
      e.dictData.forEach((v: any, m: any) => {
        if (v.checked && v.dictValue != "-1") {
          aList.push({
            ...v,
            index: i,
            subIndex: m,
            type: e.type,
          });
        }
      });
    }
  });
  return aList;
});
const initInputData = ()=>{
  options.min=''
  options.max=''
  options.quantityStart=''
  options.quantityEnd=''
  options.date=[]
  options.text = "";
}
const createQueryParams = () => {
  console.log('options.filterData', _.cloneDeep(options.filterData))
  let arr: any = options.filterData;
  let obj: any = {};
  arr.forEach((e: any) => {
    if(e.query === 'assetType' || e.query === 'region' || e.query === 'assetClassify'){
       obj[e.query] = [];
    }else{
      obj[e.query] = ''
    }
    if (e.dictData.length) {
      e.dictData.forEach((v: any) => {
        if(v.checked && v.dictValue == -1){
           if(Array.isArray(obj[e.query])){
            obj[e.query] = [];
          }else{
            obj[e.query] = ''
          }
        }
        else if (v.checked && v.dictValue != -1) {
          if(Array.isArray(obj[e.query])){
            obj[e.query].push(v.dictValue);
          }else{
            obj[e.query]=v.dictValue
          }
          
        }
      });
    }
  });
  obj.priceStart = options.min;
  obj.priceEnd = options.max;
  obj.quantityStart = options.quantityStart;
  obj.quantityEnd = options.quantityEnd;
  obj.info = options.text;
  if (options.date instanceof Array) {
    if (options.date.length >= 1) {
      obj.publishTimeStart = options.date[0];
      obj.publishTimeEnd = options.date[1];
    }
  }
  return obj;
};
const clear = () => {
  initInputData()
  clearAll()
  setTimeout(() => {
    emit("change", createQueryParams());
  }, 800);
};
const handleClose = (item: any) => {
  let index: any = item.index;
  let subIndex: any = item.subIndex;
  options.filterData[index]["dictData"][subIndex].checked = false;
  let nLen = options.filterData[index]["dictData"].length;
  options.filterData[index]["dictData"].forEach((e: any) => {
    if (!e.checked) {
      nLen--;
    }
  });
  if (!nLen) {
    options.filterData[index]["dictData"][0].checked = true;
  }
  emit("change", createQueryParams());
};

const subtext = (index: any) => {
  emit("change", createQueryParams());
};
const quantext = (index: any) => {
  emit("change", createQueryParams());
};

const subPrice = (index: any) => {
  options.filterData[index].dictData.forEach((e: any) => {
    e.checked = false;
  });
  emit("change", createQueryParams());
};
const empty = (index: any, type) => {
  options.filterData[index].dictData.forEach((e: any) => {
    if (type === 'asset_price') {
      options.min = "";
      options.max = "";
    } else {
      options.quantityStart = "";
      options.quantityEnd = "";
    }

  });
  options.filterData[index].dictData.forEach((e: any) => {
    e.checked = false;
  });
  options.filterData[index].dictData[0].checked = true;
  emit("change", createQueryParams());
};

const subDate = (item: any, index: any) => {
  console.log(options.date)
  if (options.date == null || Object.keys(options.date).length == 0) {
    options.date = [];
    options.filterData[index].dictData.forEach((e: any) => {
      e.checked = false;
    });
    options.filterData[index].dictData[0].checked = true;
  }
  else {
    options.filterData[index].dictData.forEach((e: any) => {
      e.checked = false;
    });
  }
  emit("change", createQueryParams());
};

 const checkItem = async(item: any, subItem: any, subIndex: any) => {
  // console.log("========", item, subItem, subIndex);

  if (item.type == 'city') {
    if (subItem.dictValue == -1) {
      let dictData = [];
      dictData.unshift({
        dictValue: -1,
        dictName: '全部',
        checked: true
      })
      options.filterData[2].dictData = dictData;
    } else {
      // getSubordinateAreaById({
      //   areaId: subItem.dictValue
      // }).then(res => {
        
      // })

      const res = await  getSubordinateAreaById({
        areaId: subItem.dictValue
      })
      if (res.code == 200) {
          let result = res.data;
          let dictData = [];
          console.log('result', result)
          for (let i = 0; i < result.length; i++) {
            dictData.push({
              dictValue: result[i].areaId,
              dictName: result[i].areaName
            })
          }
          dictData.unshift({
            dictValue: -1,
            dictName: '全部',
            checked: true
          })
          options.filterData[2].dictData = dictData;
        }
    }
  }
  if (subIndex !== 0) {
    if (item.type === "asset_publish" || item.type === "asset_price" || item.type == "city" || item.type === "asset_quantity") {
      if (item.type === "asset_price") {
        options.min = null;
        options.max = null;
      } else if (item.type === "asset_quantity") {
        options.quantityStart = null;
        options.quantityEnd = null;
      } else if (item.type === "asset_publish") {
        options.date = [];
      }
      item.dictData.forEach((v: any) => {
        v.checked = false;
      });
      item.dictData[subIndex].checked = true;
    } else {
      item.dictData[0].checked = false;
      subItem.checked = !subItem.checked;
      const hasFalse = item.dictData.every((obj: any) => obj.checked == false);
      console.log(hasFalse)
      if (hasFalse) {
        item.dictData[0].checked = true;
      }
    }
  } else {
    item.dictData.forEach((e: any) => {
      e.checked = false;
    });
    item.dictData[0].checked = true;
  }
  emit("change", createQueryParams());
};
const clearAll = () =>{
  let id = 1;
  options.filterData.forEach((e: any) => {
    if (e.dictData.length) {
      e.dictData.forEach((v: any, i: number) => {
        id++;
        v.id = id;
        if (i == 0) {
          v.checked = true;
        } else {
          v.checked = false;
        }
      });
    }
})
}
const getFilter = async () => {
  const areaRes = await getAreaByType({ areaType: 1 })
  const res = await getDistTypesData(enumList.map((d) => {
    return d.type
  })) as any
  let id = 1;
  const distList = res.data
  enumList.forEach((e) => {
    if (e.type === 'city') {
      e.dictData = areaRes.data.map((area: any) => {
        return {
          dictName: area.areaName,
          dictValue: area.areaId
        }
      })
      e.dictData.unshift({ dictName: '全部', dictValue: -1, checked: true })
    }
    
    const dataObj = distList.find((o:any) =>{
      return o.type === e.type
    }) 

    if(dataObj){
    //  e.dictData = dataObj.dictData || []
    //  e.name === dataObj.name
     Object.assign(e,dataObj)
    }
    dataObj && dataObj.dictData.unshift({ dictName: '全部', dictValue: -1 })
    // if (e.type != 'city' && e.type != 'region') {
    //   e.dictData = dataObj.dictData || []
    // }

    if (e.dictData.length) {
      e.dictData.forEach((v: any, i: number) => {
        id++;
        v.id = id;
        if (i == 0) {
          v.checked = true;
        } else {
          v.checked = false;
        }
      });
    }
  });
  console.log('enumList',enumList)
  options.filterData = enumList
  emit("change", createQueryParams());
}
onMounted(() => {
  getFilter()
})
</script>

<style lang="scss" scoped>
.filterBar {
  border: 1px solid #ebeced;
  display: flex;
  flex-direction: column;
  margin: 24px;

  .item {
    display: flex;
    height: 48px;
    border-bottom: 1px solid #ebeced;
    background-color: #fff;

    .label {
      background-color: #f2f2f2;
      border-right: 1px solid #ebeced;
      color: #333333;
      width: 104px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .info {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      height: 48px;
      position: relative;

      span {
        padding: 6px 12px;
        border-radius: 4px;
        cursor: pointer;
        margin: 0 6px;

        &.checked {
          background-color: #c08c58;
          color: #fff;
        }
      }

      .box {
        position: absolute;
        top: 0;
        z-index: 11;
        padding: 10px;
        width: 206px;
        height: 32px;
        &.quantity{
          z-index: 10;
        }
        .input-box {
          width: 100%;
          display: flex;
          justify-content: space-between;
        }

        .button-box {
          display: none;

          .clear {
            color: #999;
          }
        }

        &:hover {
          background-color: #fff;
          border: 1px solid #ebeced;
          box-shadow: 2px 3px 12px rgb(0 0 0 / 8%);
           height: 100px;
          .button-box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: 10px 0;
          }
        }
      }
    }
  }
}

.numberRange {
  display: flex;
  align-items: center;

  .input {
    width: 120px;
  }

  .symbol {
    margin: 5px 10px 0 10px;
  }
}

.dateRange {
  display: flex;
  align-items: center;
}
</style>
